import React, { useState, useEffect } from 'react';
import { Link, withRouter, Route, Switch } from 'react-router-dom';
import { Layout, Tabs, Icon, Button } from 'antd';
import SectionContent from '../../components/SectionContent';
import SectionTitle from '../../components/SectionTitle';
import MyEvents from './events/MyEvents';
import AllEvents from './events/AllEvents';
import useBreakpoint from 'use-breakpoint';
import { defaultBreakpoints } from '../../utils/defaultBreakpoints';
import SearchFilterBar from './leagues/SearchFilterBar';
import * as routes from '../../config/routes';
import _ from 'lodash';

const { TabPane } = Tabs;

const styles = {
    headerImg: {
        background: `linear-gradient(-90deg, #002eaf, #008dd0) 100% 100% no-repeat`,
        // background: `linear-gradient(0deg, rgba(0,0,0,0.2), rgba(0,0,0, 0.2)), url(${blueBg})`,
        // backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%',
        // backgroundPosition: '0px -400px'

        // backgroundPosition: '0px -40px'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // height: '100%'
    },
};

function Events(props) {
    const { history } = props;
    const urlPath = window.location.pathname;
    const params = props.match.params;
    const slug = params.slug;
    const splitPath = urlPath.split('/');
    const dpIncludes = ['my-events', 'all-events'];
    const [current, setCurrent] = useState('all-events');
    const { breakpoint, maxWidth, minWidth } = useBreakpoint(defaultBreakpoints);

    const handleTabClick = (tab) => {
        setCurrent(tab);
        props.history.push(`/events/${tab}`);
    };

    useEffect(() => {
        let pathMatch = _.includes(dpIncludes, splitPath[splitPath.length - 1])
            ? splitPath[splitPath.length - 1]
            : _.includes(dpIncludes, splitPath[splitPath.length - 2])
            ? splitPath[splitPath.length - 2]
            : _.includes(dpIncludes, splitPath[splitPath.length - 3])
            ? splitPath[splitPath.length - 3]
            : 'all-events';

        setCurrent(pathMatch);
    }, [urlPath, dpIncludes, splitPath, params]);

    return (
        <Layout className="events-page">
            <div style={styles.headerImg}>
                <SectionTitle title={props.title} height={breakpoint === 'mobile' ? 80 : 100}>
                    <Link to="/events/new">
                        {breakpoint === 'mobile' ? (
                            <Button size="large" type="ghost" ghost>
                                <Icon type="plus" />
                            </Button>
                        ) : (
                            <Button size="large" type="ghost" ghost>
                                Create Event
                                <Icon type="arrow-right" />
                            </Button>
                        )}
                    </Link>
                </SectionTitle>

                {props.authState && props.authState.user && props.authState.user.id ? (
                    <Tabs
                        defaultActiveKey={current}
                        activeKey={current}
                        animated={{ inkBar: true, tabPane: false }}
                        // renderTabBar={() => <ScrollableInkTabBar />}
                        // renderTabContent={() => <TabContent />}
                        onTabClick={handleTabClick}
                        className="tabs-bg"
                        tabPosition="top"
                        tabBarStyle={{
                            textTransform: 'uppercase',
                            paddingLeft: 24,
                            paddingRight: 24,
                            paddingTop: 0,
                            // backgroundColor: '#132339',
                            boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 15px 0px',
                            color: '#fff',
                            zIndex: 1,
                            position: 'relative',
                            borderBottom: 'none',
                            borderTop: '1px solid rgba(255,255,255,0.1)',
                        }}
                    >
                        <TabPane tab="All Events" key="all-events" style={styles.tab}>
                            <Switch>
                                <Route path={routes.DIGITALPOOL.EVENTS} render={(matchProps) => <AllEvents {...matchProps} {...props} />} />
                            </Switch>
                        </TabPane>
                        <TabPane tab="My Events" key="my-events" style={styles.tab}>
                            <Switch>
                                <Route path={routes.DIGITALPOOL.MY_EVENTS} render={(matchProps) => <MyEvents {...matchProps} {...props} />} />
                                <Route path={routes.DIGITALPOOL.EVENTS} render={(matchProps) => <MyEvents {...matchProps} {...props} />} />
                            </Switch>
                        </TabPane>
                    </Tabs>
                ) : (
                    <AllEvents {...props} />
                )}
            </div>
        </Layout>
    );
}

export default withRouter(Events);
